import React from 'react';

const ReservantContext = React.createContext({
  reservants: [],
  typesReservant: [],
});

export default ReservantContext;
